<app-breadcrumb [master]="'Należności'" [parentName]="'Przelewy'" [name]="'Dodaj'"></app-breadcrumb>
<div class="transfer-add" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!formValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Nazwa odbiorcy</mat-label>
              <input appCapitalizeFirst matInput placeholder="Nazwa odbiorcy" [formControl]="nameControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Tytuł przelewu</mat-label>
              <input appCapitalizeFirst matInput placeholder="Tytuł przelewu" [formControl]="transferTitleControl">
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Numer konta</mat-label>
              <input  prefix="PL" mask=" 00 0000 0000 0000 0000 0000 0000" [dropSpecialCharacters]="false"
                      matInput placeholder="PL 27 1140 2004 0000 3002 0135 5387" [formControl]="accountNumberControl">
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Kwota przelewu</mat-label>
              <input   matInput
                       type="number"
                       placeholder="Kwota przelewu"
                       step="0.01"
                       [formControl]="transferAmountControl" >
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" >
          <mat-form-field fxFlex="100">
            <mat-label>Uwagi</mat-label>
            <textarea [formControl]="noteControl" matInput placeholder="Uwagi"></textarea>
          </mat-form-field>
        </div>

      </mat-card>

    </div>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!formValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
